import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Flex,
  useDisclosure,
  Icon,
} from '@wegroup/design-system';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

interface Props {
  alertText: string;
}

const ToolbarBackToDashboardButton: React.FC<
  React.PropsWithChildren<Props>
> = ({ alertText }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const cancelRef = useRef<HTMLButtonElement>(null);

  const { isOpen, onClose, onOpen } = useDisclosure();

  const handleOnClick = () => {
    history.push(`/dashboard`);
    onClose();
  };

  return (
    <>
      <Flex mt="4" cursor="pointer" sx={{ svg: { w: '7', h: '7' } }}>
        <Button
          leftIcon={<Icon name="IconChevronLeftRounded" color="secondary.50" />}
          variant="link"
          color="secondary.50"
          onClick={onOpen}
        >
          {t('Return to dashboard')}
        </Button>
      </Flex>
      <AlertDialog
        motionPreset="slideInBottom"
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader textStyle="largeBodyBold">
              {t('Go back?')}
            </AlertDialogHeader>

            <AlertDialogBody>{alertText}</AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} variant="grayedGhost" onClick={onClose}>
                {t('Cancel')}
              </Button>
              <Button onClick={handleOnClick} ml={3}>
                {t('Go back')}
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default ToolbarBackToDashboardButton;
